import { Controller } from '@hotwired/stimulus';
import { eventListener } from '@inked/utilities';
import { gsap } from 'gsap';

export class InkedSubmarkController extends Controller {
  static targets = ['radial'];

  connect() {
    this.stopMouseAndTouchEvents = eventListener(
      this.element,
      [
        'mouseout',
        'mouseover',
        'touchend',
        'touchstart',
      ],
      () => this.reverse(),
    );

    this.animate();
  }

  disconnect() {
    if (this.animation) this.animation.kill();
    if (this.stopMouseAndTouchEvents) this.stopMouseAndTouchEvents();
  }

  animate() {
    this.animation = gsap.to(this.radialTarget, {
      duration: 100,
      ease: 'none',
      repeat: -1,
      rotation: 360,
    });
  }

  reverse() {
    if (!this.animation) return;

    this.animation.vars.rotation = this.animation.vars.rotation * -1;

    this.animation.invalidate().restart();
  }
};
